import {Component, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {InventoryCustomObjectSearchPageComponent} from "../custom-object-search-page/inventory-custom-object-search-page.component";

export class InventoryCustomObjectReportSelectionData extends EntityData<InventoryCustomObjectReportSelectionData> {
    @identifier customObjectId: number;
    @field name: string;
    @field customGroupType: string;
}

@Component({
    selector: "wbo-inventory-custom-object-report-selection",
    templateUrl: "./inventory-custom-object-report-selection-control.component.html"
})
export class InventoryCustomObjectReportSelectionControlComponent {

    InventoryCustomObjectSearchPageComponent = InventoryCustomObjectSearchPageComponent;

    fieldName: string = "customObjects";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromCustomObject(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((customObject: any) => customObject.customObjectId === item.customObjectId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
